// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes rotate-center-data-v-932e9550{0%{transform:rotate(0)}to{transform:rotate(1turn)}}.loading-animation[data-v-932e9550]{animation:rotate-center-data-v-932e9550 1s infinite;height:10rem;z-index:1000}.loading-page[data-v-932e9550]{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.8);text-align:center;padding-top:200px;font-size:30px;font-family:sans-serif;z-index:1000}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
